export function stickyHeaderMobile() {
  var posicionAnterior = 0;
  var posCabecera = 'suelta';
  var estadoCabecera = 'visible';

  var navPortada = document.querySelector('body>.navegacion');
  var cabeceraPortada = document.querySelector('body>.cabecera');

  function fijarCabeceraSticky() {
    if(cabeceraPortada.parentElement.classList.contains('portada') || cabeceraPortada.parentElement.classList.contains('subportada')) {
      cabeceraPortada.classList.add('a-portada-seccion');
    }
    cabeceraPortada.classList.add('cabecera-sticky');
    cabeceraPortada.previousElementSibling.style.marginBottom = '50px';
    return 'fija';
  }

  function soltarCabeceraSticky() {
    if(cabeceraPortada.parentElement.classList.contains('portada') || cabeceraPortada.parentElement.classList.contains('subportada')) {
      cabeceraPortada.classList.remove('a-portada-seccion');
    }
    cabeceraPortada.classList.remove('cabecera-sticky');
    cabeceraPortada.previousElementSibling.style.marginBottom = '0px';
    return 'suelta';
  }

  function cabeceraStickyVisible() {
    cabeceraPortada.classList.add('visible');
    return 'visible';
  }
  
  function cabeceraStickyOculta() {
    cabeceraPortada.classList.remove('visible');
    return 'noVisible';
  }

  if(navPortada && cabeceraPortada) {
    var delay = false;
    var posicionCabecera = cabeceraPortada.offsetTop+cabeceraPortada.offsetHeight;
    setTimeout(function(){
      document.addEventListener('scroll',function(){
        if(delay) return;
        if(window.scrollY>posicionCabecera) {
          if(posCabecera==='suelta') posCabecera = fijarCabeceraSticky();
          if(window.scrollY>posicionAnterior && estadoCabecera==='visible') {
            estadoCabecera = cabeceraStickyOculta();
          }
          if(window.scrollY<posicionAnterior && estadoCabecera==='noVisible') {
            estadoCabecera = cabeceraStickyVisible();
          }
        } else if((window.scrollY<posicionCabecera-cabeceraPortada.offsetHeight) || (window.scrollY==0)) {
          if(posCabecera==='fija') {
            posCabecera = soltarCabeceraSticky();
            estadoCabecera = cabeceraStickyOculta()
          }
        }
        posicionAnterior = window.scrollY;
        delay=true;
        setTimeout(function() {
          delay = false;
          if (window.scrollY==0) posCabecera = soltarCabeceraSticky();
        }, 50);
      });
    },500);
  }
}

export function stickyHeaderDesktop() {
  var navPortada = document.querySelector('body>.navegacion');
  var menuStickyPortada = document.querySelector('.cabecera-sticky');
  var capaMenu = document.querySelector('.cabecera-sticky .capa-todo');
  var botonUsuarioLogin = document.querySelector('[data-abre-menu-usuario-login]'),
      menuUsuarioLogin = document.querySelector('[data-menu-usuario-login]'),
      botonAlertaLogin = document.querySelector('[data-abre-menu-alerta-login]'),
      menuAlertaLogin = document.querySelector('[data-menu-alerta-login]'),
      botonUsuarioLogout = document.querySelector('[data-abre-menu-usuario-logout]'),
      botonUsuarioLoginSticky = document.querySelector('[data-abre-menu-usuario-login-sticky]'),
      botonUsuarioLogoutSticky = document.querySelector('[data-abre-menu-usuario-logout-sticky]'),
      menuUsuarioLoginSticky = document.querySelector('[data-menu-usuario-login-sticky]'),
      botonAlertaLoginSticky = document.querySelector('[data-abre-menu-alerta-login-sticky]'),
      menuAlertaLoginSticky = document.querySelector('[data-menu-alerta-login-sticky]');

  function cabeceraStickyVisible() {  
    menuStickyPortada.classList.add('visible');
    if (menuUsuarioLogin) {
      menuUsuarioLogin.classList.remove('visible');
    }
    if (menuAlertaLogin) {
      menuAlertaLogin.classList.remove('visible');
    }
    if (botonUsuarioLogin) {
      botonUsuarioLogin.classList.remove('visible');
    }
    if (botonUsuarioLogout) {
      botonUsuarioLogout.classList.remove('visible');
    }
    if (botonAlertaLogin) {
      botonAlertaLogin.classList.remove('visible');
    }
    return 'visible';
  }

  function cabeceraStickyOculta() {
    menuStickyPortada.classList.remove('visible');
    capaMenu.style.display = 'none';
    if (menuUsuarioLoginSticky) {
      menuUsuarioLoginSticky.classList.remove('visible');
    }
    if (menuAlertaLoginSticky) {
      menuAlertaLoginSticky.classList.remove('visible');
    }
    if (botonUsuarioLoginSticky) {
      botonUsuarioLoginSticky.classList.remove('visible');
    }
    if (botonUsuarioLogoutSticky) {
      botonUsuarioLogoutSticky.classList.remove('visible');
    }
    if (botonAlertaLoginSticky) {
        botonAlertaLoginSticky.classList.remove('visible');
    }
    return 'oculta';
  }

  if(capaMenu && navPortada && menuStickyPortada) {
    var delay = false;
    //if(capaMenu.previousElementSibling.classList.contains('todo')) capaMenu.previousElementSibling.addEventListener('click',function(){capaMenu.style.display = 'flex'});
    var posicionNavPortada = navPortada.getBoundingClientRect().bottom>0?cabeceraStickyOculta():cabeceraStickyVisible();
    document.addEventListener('scroll',function(){
      if(delay) return;
      if((navPortada.getBoundingClientRect().bottom)<=0 && posicionNavPortada=='oculta') {
        posicionNavPortada = cabeceraStickyVisible();
      }
      if((navPortada.getBoundingClientRect().top)>0 && posicionNavPortada=='visible') {
        posicionNavPortada = cabeceraStickyOculta();
      }
      delay=true;
      setTimeout(function() {
        delay = false;
      }, 100);
    });
  }

}



// WEBPACK FOOTER //
// ./src/scripts/layout/sticky-header.js